import { render, staticRenderFns } from "./CommonModalWithVoteDisplay.vue?vue&type=template&id=56bc146c&lang=pug&"
import script from "./CommonModalWithVoteDisplay.vue?vue&type=script&lang=ts&"
export * from "./CommonModalWithVoteDisplay.vue?vue&type=script&lang=ts&"
import style0 from "./CommonModalWithVoteDisplay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports